import React from 'react';
import { Grid } from '@mantine/core';
import PropTypes from 'prop-types';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import MediaDropzone from '../media/MediaDropzone';
import CreationWizardButton from './CreationWizardButton';

const StoreCreationSetupCustomProductsStep = ({
  loading,
  createOptions,
  formState,
  setFormState
}) => {
  const { includeCustomProducts } = formState.customProducts;

  return (
    <AppStack style={{ gap: 10, paddingTop: 10 }}>
      <Grid>
        <Grid.Col span={6}>
          <CreationWizardButton
            label="Skip custom products"
            onClick={() => {
              setFormState({
                ...formState,
                customProducts: {
                  ...formState.customProducts,
                  includeCustomProducts: false
                }
              });
            }}
            selected={includeCustomProducts === false}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <CreationWizardButton
            label="Upload design logo"
            onClick={() => {
              setFormState({
                ...formState,
                customProducts: {
                  ...formState.customProducts,
                  includeCustomProducts: true
                }
              });
            }}
            selected={includeCustomProducts === true}
          />
        </Grid.Col>
      </Grid>

      {includeCustomProducts === false ? (
        <AppStack
          style={{
            gap: 0,
            marginTop: 10,
            flex: 1,
            padding: '0px 40px',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <AppText
            style={{
              fontSize: 14,
              color: '#666',
              fontStyle: 'italic',
              textAlign: 'center'
            }}
          >
            You can always add custom products later from the store dashboard.
          </AppText>
        </AppStack>
      ) : (
        includeCustomProducts === true && (
          <AppStack
            style={{
              gap: 20,
              marginTop: 10,
              flex: 1,
              justifyContent: 'center'
            }}
          >
            <AppStack
              style={{
                flex: 1,
                padding: '0px 40px'
              }}
            >
              <AppText
                style={{
                  fontSize: 14,
                  color: '#666',
                  fontStyle: 'italic',
                  textAlign: 'center'
                }}
              >
                Please upload the design logo you would like to use for your
                custom products.
              </AppText>
            </AppStack>

            <AppStack>
              <MediaDropzone
                disabled={formState.loading}
                disableDirectUrl
                files={[]}
                height={200}
                maxSelectCount={1}
                onUpload={(media) => {
                  setFormState({
                    ...formState,
                    customProducts: {
                      ...formState.customProducts,
                      imageUrl: null,
                      imageFile: media[0],
                      imagePreview: media[0]?.preview
                    }
                  });
                }}
                selectedPreview={formState.customProducts.imagePreview}
              />
            </AppStack>
          </AppStack>
        )
      )}
    </AppStack>
  );
};

StoreCreationSetupCustomProductsStep.propTypes = {
  createOptions: PropTypes.object,
  formState: PropTypes.object,
  loading: PropTypes.bool,
  setFormState: PropTypes.func
};

export default StoreCreationSetupCustomProductsStep;
